<template>
  <div>
    <div class="container my-3" style="min-height:50vh">
      <div class="row">
        <div class="col-12">
          <div class="d-flex title-box">
            <div class="title" :class="{'active' : type==='vocabulary'}"  @click="goPage('vocabulary')">{{ copy.vocabulary }}</div>
            <div class="title" :class="{'active': type==='lesson'}" @click="goPage('lesson')">{{ copy.course }}</div>
          </div>
        </div>
      </div>
      <!-- <div class="row my-3" v-if="type==='daily'">
        <div v-for="(item, index) in collections" :key="index" class="content-box col-12 my-2">
          <div :key="index" class="row align-items-center" style="min-height:100px">
            <div class="d-flex col-md-2">
              <div>
                <img @click="removeAlert(apiType,item.data.id)" class="pointer" src="../assets/image/pic/btn_function_mark_on.png" alt="">
              </div>
              <div class="my-auto">
                <h5 class="p-0 my-0 mx-2" style="font-weight: bolder;">
                  {{moment(item.json.publish_at).format('YYYY/MM/DD') }}
                </h5>
              </div>
            </div>
            <div class="col-md-8 my-2">
              <p class="p-0 my-1">{{item.name}}</p>
              <p class="p-0 my-1">{{item.json.local}}</p>
            </div>
            <div class="col-md-2" style="text-align:right">
              <img class="mx-1 pointer" @click="playAudio(item.id, 'daily-sentences')" src="../assets/image/pic/icon_voice.png" alt="">
            </div>
          </div>
          <div v-if="item.json.audio_url">
            <audio :id="`daily-sentences${item.id}`">
              <source :src="item.json.audio_url" type="audio/ogg">
            </audio>
          </div>
        </div>
      </div> -->
      <div class="row my-3" v-if="type==='vocabulary'">
        <div class="container">
          <div class="row">
            <div class="col">
              <div v-for="(item, index) in collections" :key="index" class="my-3">
                <div :key="index" class="row align-items-center content-box" style="min-height:100px">
                  <div class="col-md-1">
                    <div class="my-auto">
                      <img @click="removeAlert(apiType,item.json.params.courseId,item)" class="pointer" src="../assets/image/pic/btn_function_mark_on.png" alt="">
                    </div>
                  </div>
                  <div class="col-md-2">
                    <div class="my-auto mx-2 d-flex pointer" @click="playAudio(item.id, 'word')">
                      <p class="p-0 my-1 main-title"> {{item.name}} </p>
                      <img class="my-auto mx-2 pointer" src="../assets/image/pic/icon_voice.png" alt="">
                    </div>
                  </div>
                  <div class="col-md-2 d-flex">
                    <div class="my-auto mx-2 pointer">
                      <p class="p-0 my-1">{{item.json.vocabulary.pronouncing}}</p>
                    </div>
                  </div>
                  <div class="col-md-5 d-flex">
                    <div class="my-auto mx-2">
                      <p class="p-0 my-1">{{item.json.vocabulary.partOfSpeech}} {{item.json.vocabulary.name_i18N[0].value}}</p>
                    </div>
                  </div>
                  <div class="col-md-2" style="text-align:right">
                    <button type="button" @click="goLesson(item)" class="btn btn-danger">{{ copy.sourceCourse }}</button>
                  </div>
                </div>
                <div v-if="item.json.vocabulary.audio">
                  <audio :id="`word${item.id}`">
                    <source :src="item.json.vocabulary.audio" type="audio/mp3">
                  </audio>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="row my-3" v-if="type==='lesson'">
        <div v-for="(item, index) in collections" :key="index" class="col-12" >
          <div :key="index" class="row align-items-center my-2">
            <div class="col-md-6 d-flex align-content-center m-0 p-0" style="height:80px;">
              <div class="content-box">
                <img @click="removeAlert(apiType,item.data.id)" class="pointer my-3" src="../assets/image/pic/btn_function_mark_on.png" alt="">
              </div>
              <div class="picture image-box pointer ml-2" style="width:100%;" >
                <img :src="item.json.banner" alt="">
                <h5 class="p-0 my-0">
                  <!-- <span style="font-size:.8rem;">我想xxxx>xxxx</span> <br> -->
                  {{item.data.name}}
                </h5>
              </div>
            </div>
            <div class="col-md-6 d-flex content-box my-2" style="height:80px">
              <!-- <div class="my-auto mr-2">
                <span class="badge badge-danger">{{item.data.cefr}}</span>
              </div> -->
              <div class="my-auto" style="width:75%">
                <p class="p-0 my-0">{{item.data.name_en}}</p>
              </div>
              <div class="my-auto">
                <button type="button" @click="goLesson(item)" class="btn btn-danger">{{ copy.enterCourse }}</button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="container">
        <popUp v-if="toggle && videoData" v-on:doClose="close">
          <div class="pop-title" slot="title">
            <h6>{{moment(videoData.json.public_at).format('YYYY/MM/DD') }}</h6>
            <h5>{{videoData.data.name}}</h5>
            <h6>{{videoData.data.name_en}}</h6>
          </div>
          <div slot="info" class="info-main" >
            <div class="video-box" v-if="videoData">
              <player style="width:100%;background:black;" class="m-auto my-3" :url="videoData.json.url"/>
            </div>
          </div>
        </popUp>
        <div class="row" v-if="type ==='english'">
          <div class="col">
            <div v-for="(item, index) in collections" :key="index" class="my-3">
              <div :key="index" class="row align-items-center content-box" style="min-height:100px">
              <div class="d-flex col-md-2">
                <div class="my-auto">
                  <img @click="removeAlert(apiType,item.data.id)" class="pointer" src="../assets/image/pic/btn_function_mark_on.png" alt="">
                </div>
                <div class="my-auto">
                  <h5 class="p-0 my-0 mx-2" style="font-weight: bolder;">
                    {{moment(item.json.public_at).format('YYYY/MM/DD') }}
                  </h5>
                </div>
              </div>
              <div class="col-md-7 d-flex">
                <div class="my-auto mx-2">
                  <p class="p-0 my-1 main-title">{{item.data.name}}</p>
                  <p class="p-0 my-1">{{item.data.name_en}}</p>
                </div>
              </div>
                <div class="col-md-3" style="text-align:right">
                  <button type="button" @click="openVideo(item)" class="btn btn-danger mx-auto px-4">{{ copy.more }}</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="row align-items-center" style="height:200px"  v-if="collections">
        <div class="col" v-if="collections.length===0">
          <h4 class="my-auto" style="color:#8b8b8b">{{ copy.emptyCollections }}</h4>
        </div>
      </div>
    </div>
    <div v-if="collections">
      <pagination v-if="pageCount>1 && collections.length>0" class="m-auto pt-4" :current="pageIndex" :total="pageCount" v-on:page="toPage"/>
    </div>
  </div>
</template>
<script>
// @ is an alias to /src
// import Video from '@/components/Video.vue'
import Player from 'live-player/dist/Player'
import LivePlayer from 'live-player'
import PopUp from '@/components/PopUp.vue'
import Pagination from '@/components/Pagination.vue'
// import libraryApi from '../store/library/api'
import api from '../store/api'
export default {
  name: 'Collections',
  data () {
    return {
      type: 'vocabulary',
      collections: null,
      dailyNews: null,
      toggle: false,
      videoData: null,
      pageIndex: 1,
      pageCount: 0
    }
  },
  components: {
    LivePlayer,
    Player,
    PopUp,
    Pagination
  },
  computed: {
    currentLocale () {
      return this.$i18n ? this.$i18n.locale : 'tw'
    },
    copy () {
      const copy = {
        tw: {
          vocabulary: '\u55ae\u5b57',
          course: '\u8ab2\u7a0b',
          sourceCourse: '\u4f86\u6e90\u8ab2\u7a0b',
          enterCourse: '\u9032\u5165\u8ab2\u7a0b',
          emptyCollections: '\u60a8\u9084\u6c92\u6709\u6536\u85cf\u7d00\u9304',
          deleteTitle: '\u78ba\u8a8d\u522a\u9664?',
          confirm: '\u78ba\u8a8d',
          cancel: '\u53d6\u6d88',
          more: 'More'
        },
        en: {
          vocabulary: 'Vocabulary',
          course: 'Courses',
          sourceCourse: 'Source Course',
          enterCourse: 'Enter Course',
          emptyCollections: 'You do not have any saved collections yet.',
          deleteTitle: 'Delete this item?',
          confirm: 'Confirm',
          cancel: 'Cancel',
          more: 'More'
        }
      }
      return copy[this.currentLocale] || copy.tw
    },
    apiType () {
      switch (this.type) {
        case 'lesson':
          return 'course'
        case 'vocabulary':
          return 'word'
        case 'daily':
          return 'daily_sentence'
        case 'news':
          return 'daily_news'
        case 'english':
          return 'daily_english'
      }
      return null
    },
    personalData () {
      return this.$store.state.auth.personalData || this.$store.state.personalData || {}
    },
    groupId () {
      return this.personalData.group_id || ''
    },
    studentId () {
      return this.personalData.student_id || ''
    }
  },
  mounted () {
    this.getCollections(this.apiType)
  },
  watch: {
    apiType (val) {
      this.collections = null
      this.getCollections(val)
    }
  },
  methods: {
    goPage (el) {
      this.type = el
    },
    goLesson (el) {
      const self = this
      if (this.type === 'vocabulary') {
        this.$router.push({ name: 'CourseLesson', params: { lesson: el.json.params.lesson, groupId: self.groupId, studentId: self.studentId, courseId: el.json.params.courseId } })
      }else {
        this.$router.push({ name: 'CourseLesson', params: { lesson: el.data.id, groupId: self.groupId, studentId: self.studentId, courseId: el.json.view_id } })
      }
    },
    async getCollections (type) {
      try {
        const { data } = await api.get(`collections/${type}?page=${this.pageIndex}&pageSize=10`)
        this.collections = data.data
        this.pageCount = data.pageCount
      } catch (error) {
        console.error(error.response.data)
      }
    },
    removeAlert (type, id, el) {
      let self = this
      self.$swal({
        title: self.copy.deleteTitle,
        showCancelButton: true,
        confirmButtonText: self.copy.confirm,
        cancelButtonText: self.copy.cancel,
        closeOnConfirm: false
      }).then(function (isConfirm) {
        if (isConfirm.value === true) {
          self.removeCollections(type, id, el)
        }
      })
    },
    async removeCollections (type, id, el) {
      if (type === 'word') {
        try {
          const config = {
            data: {
              word: el.name
            }
          }
          await api.delete(`collections/${type}/${id}`, config)
          this.getCollections(this.apiType)
        } catch (error) {
          // console.error(error.response.data)
        }
      } else {
        try {
          await api.delete(`collections/${type}/${id}`)
          this.getCollections(this.apiType)
          // console.log(data)
        } catch (error) {
          console.error(error.response.data)
        }
      }
    },
    playAudio (id, type) {
      console.log(id)
      this.isPlay = id
      this.playSentences(id, type)
    },
    playSentences (id, type) {
      // console.log(`${type}${id}`)
      const audio = document.getElementById(`${type}${id}`)
      this.pauseAll()
      audio.load()
      audio.play()
    },
    pauseAll () {
      const audios = document.getElementsByTagName('audio')
      const self = this
      const allAudios = []
      allAudios.forEach.call(audios, function (i) {
        i.currentTime = 0
        i !== self && i.pause()
      })
    },
    toPage (toPage) {
      this.pageIndex = toPage
      this.getCollections(this.apiType)
    },
    close (close) {
      this.toggle = close
      this.videoData = null
    },
    openVideo (el) {
      this.videoData = el
      this.toggle = true
    },
  }
}
</script>
<style lang="scss" scoped>
  .banner {
    height: 300px;
    background-image: url('../assets/image/pic/pic_blur_bg.jpg');
    // padding: 100px;
    // width: 100vw;
  }
  .title-box {
    margin-bottom: 20px;
    border-top: #aaa solid 1px;
    border-bottom: #aaa solid 1px;
    padding: 10px 0;
    .title {
      color: #aaa;
      margin: 0 50px 0 0;
      cursor: pointer;
    }
    .active {
      color: black;
    }
  }
  .picture {
    max-height: 80px;
    min-height: 80px;
    position:relative;
    overflow: hidden;
    img {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%,-50%);
      width: 100%;
      height: 100%;
      object-fit: cover;
      transition:all 0.2s ease;
    }
    h5 {
      color: #fff;
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%,-50%);
    }
  }
  .content-box {
    height: 100%;
    background-color: rgb(230, 230, 230);
    text-align: left;
    padding: 8px;
  }
  table {
    text-align: left;
    border-collapse: collapse;
    width: 100%;
    min-width: 500px;
  }
  td {
    background-color: rgb(230, 230, 230);
    border: 4px solid #fff;
    text-align: left;
    padding: 8px;
  }
  .main-title {
    font-size:1.2rem;
    font-weight: bolder;
  }
  .daily-sentence {
    // text-align: left;
    h5 {
      font-weight: bold;
    }
  }
  .swal2-icon.swal2-warning {
    border-color: red !important;
    color: red !important;
  }
</style>
